import React, { Component, Fragment } from 'react';
import { Menu, Button, Col, notification } from 'antd';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { history } from '../../container/History';
import './layout.css';
import MobileNavigation from "./MobileNavigation"
import SparkOpportunityForm from './SparkOpportunityForm';

const ButtonGroup = Button.Group;

const nave = [
  { name: "Dashboard", link: "/alumni-dashboard" },
  { name: "Alumni Search", link: "/alumni-search" },
  { name: "Advanced Search", link: "/advanced-search" },
  { name: "FAQ", link: "/faq" },
  { name: "ADMIN", link: "/admin-dashboard" },
]

class AlumniNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      panelView: null,
      isShowSPARK_OpportunityModal: false,
    }
    this.changeview = this.changeview.bind(this)
  }

  findPositions = (position) => {
    return this.props.postionsinfo && this.props.postionsinfo.some(info => info.personContext === position)
  }

  changeview = (panelView) => {
    let TabView = '';
  
    const alumniPanelViews = [
      'alumniTabView',
      'AlumniCouncilCommitteeTabView',
      'AlumniCSTSupportTabView',
      'AlumniAdminView'
    ];
  
    if (alumniPanelViews.includes(panelView)) {
      const isCommitteeView = this.findPositions("AlumniCouncilCommittee");
      const isCSTSupportView = this.findPositions("AlumniCSTSupport");
      const isAlumniAdminView = this.findPositions("AlumniAdmin");
  
      if (isCommitteeView) {
        TabView = 'AlumniCouncilCommitteeTabView';
      } else if (isCSTSupportView) {
        TabView = 'AlumniCSTSupportTabView';
      } else if (isAlumniAdminView) {
        TabView = 'AlumniAdminView';
      } else {
        TabView = this.props.isadmin
          ? 'adminTabView'
          : this.props.isspecialist
            ? 'specialistTabView'
            : '';
      }
  
      if (TabView !== '') {
        localStorage.setItem("panelView", JSON.stringify(TabView));
        history.push('/admin-dashboard');
      }
    } else if (panelView === 'adminTabView' || panelView === 'specialistTabView') {
      localStorage.setItem("panelView", JSON.stringify("alumniTabView"));
      history.push('/alumni-dashboard');
    }
  }

  static propTypes = {
    location: PropTypes.object.isRequired
  }

  ShowSPARK_OpportunityModal = () => {
    this.setState({
      isShowSPARK_OpportunityModal: true
    })
  }

  hideSPARK_OpportunityModal = () => {
    this.setState({
      isShowSPARK_OpportunityModal: false
    })
  }

  componentDidMount = () => {
    let getPanelView = localStorage.getItem("panelView") ? JSON.parse(localStorage.getItem("panelView")) : "alumniTabView"
    this.setState({
      panelView: getPanelView
    })
    this.props.actions.isadmin()
  }

  componentWillReceiveProps = (nextprops) => {
    // if (this.props.isSendingMail !== nextprops.isSendingMail) {
    //     nextprops.isSendingMail ? notification['error']({
    //         message: 'Error',
    //         description:
    //             `Couldn't send mail, Please try again`,
    //     }) : ''
    // }
    if (this.props.mailSent !== nextprops.mailSent) {
      if (nextprops.mailSent) {
        notification['success']({
          message: 'success',
          description:
            `Mail sent successfully`,
        })
        this.hideSPARK_OpportunityModal()
      }
    }
    if (this.props.mailFailed !== nextprops.mailFailed) {
      if (nextprops.mailFailed) {
        notification['error']({
          message: 'Error',
          description:
            `Couldn't send mail, Please try again`,
        })
      }
    }
  }

  render() {
    const { location, isSuperAlumniAdmin, isspecialist, isAlumniAdmin, isCSTSupport, isCouncilCommittee } = this.props;

    let roleToShow = null;

    if (isSuperAlumniAdmin) {
      roleToShow = "SUPER ADMIN";
    } else if (isspecialist) {
      roleToShow = "SPECIALIST";
    } else if (isAlumniAdmin) {
      roleToShow = "ALUMNI ADMIN";
    } else if (isCSTSupport) {
      roleToShow = "CST SUPPORT";
    } else if (isCouncilCommittee) {
      roleToShow = "COUNCIL COMMITTEE";
    }

    const shouldShowRoleTab = !!roleToShow;

    return (
      <Fragment >
        <div className="hidden-sm">
          <div className="ant-layout-wrapper">
            <Menu mode="horizontal" selectedKeys={[location.pathname]} defaultSelectedKeys={['/']} style={{ marginLeft: 124 }}>
              <Menu.Item key="/alumni-dashboard"> <NavLink to="/alumni-dashboard"> Dashboard </NavLink> </Menu.Item>
              <Menu.Item key="/alumni-search"> <NavLink to="/alumni-search"> Alumni Search  </NavLink> </Menu.Item>
              {/* {isSuperAlumniAdmin && (
                <Menu.Item key="/advanced-search"> <NavLink to="/advanced-search"> Advanced Search  </NavLink> </Menu.Item>
              )} */}
              {/* <Menu.Item key="/faq"> <NavLink to="/faq"> FAQ </NavLink> </Menu.Item> */}
              <Menu.Item>
                <a href="https://www.scouting.org/about/local-council-locator/">
                  <NavLink to=""> Council Locator </NavLink>
                </a>
              </Menu.Item>
            </Menu>

            <div className='NeedHelpButton'>
              <button onClick={() => history.push('/need-help-alumni')} className='Need-help-action'>
                NEED HELP
                <i class="fa fa-question-circle" aria-hidden="true"></i>
              </button>
            </div>
            {(
              ((this.props.isadmin) || (this.props.isspecialist)) && (
                  <div className='loggedin-user'>
                    <ButtonGroup className='role-btn'>
                      <span className={"active ant-btn ant-btn-scout-btn"} type="scout-btn"> ALUMNI </span>
                      <span
                        className={"ant-btn ant-btn-scout-btn"}
                        onClick={() => this.changeview("alumniTabView")}
                        type="scout-btn"
                      >
                        {/* {this.props.postionsinfo && this.props.postionsinfo.length !== 0 ? (
                          this.props.postionsinfo.map((info, index) => {
                            const rolePriority = {
                              "AlumniAdmin": 1,
                              "AlumniCSTSupport": 2,
                              "AlumniCouncilCommittee": 3
                            };

                            const sortedRoles = this.props.postionsinfo.sort((a, b) => rolePriority[a.personContext] - rolePriority[b.personContext]);

                            if (index === 0) {
                              return (
                                <span key={index}>
                                  {sortedRoles[0].personContext === "AlumniAdmin" && "ALUMNI ADMIN"}
                                  {sortedRoles[0].personContext === "AlumniCSTSupport" && "CST SUPPORT"}
                                  {sortedRoles[0].personContext === "AlumniCouncilCommittee" && "COUNCIL COMMITTEE"}
                                </span>
                              );
                            }
                            return null;
                          })
                        ) : ( */}
                      <div>
                        {/* <span>{this.props.isSuperAlumniAdmin ? "SUPER ADMIN" : ""}</span>
                        <span>{this.props.isAlumniAdmin ? "ALUMNI ADMIN" : ""}</span>
                        <span>{this.props.isCSTSupport ? "CST SUPPORT" : ""}</span>
                        <span>{this.props.isCouncilCommittee ? "COUNCIL COMMITTE" : ""}</span>
                        <span>{this.props.isspecialist ? "SPECIALIST" : ""}</span> */}
                         {shouldShowRoleTab && ( <span> {roleToShow} </span> )}
                      </div>
                        {/* )} */}
                      </span>
                    </ButtonGroup>
                  </div>
                )
            )}
          </div>
          {/* <SparkOpportunityForm 
            hideSPARK_OpportunityModalHandler = {this.hideSPARK_OpportunityModal}
            handleSubmitHandler = {this.handleSubmit}
            isShowSPARK_OpportunityModal = {this.state.isShowSPARK_OpportunityModal}
          /> */}
        </div>

        <Col className="breadcrumbMenu visible-xs">
          <MobileNavigation nave={nave} />
        </Col>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    logout: state.authenticationReducer.logout,
    profileinfo: state.profilereducer.profileinfo,

    isadmin: state.isadminreducer.isadmin,
    isspecialist: state.isadminreducer.isspecialist,
    isSuperAlumniAdmin: state.isadminreducer.isSuperAlumniAdmin,
    isCSTSupport: state.isadminreducer.isCSTSupport,
    isCouncilCommittee: state.isadminreducer.isCouncilCommittee,
    isAlumniAdmin: state.isadminreducer.isAlumniAdmin,

    isSendingMail: state.sparkOpportunityFormReducer.isSendingMail,
    mailSent: state.sparkOpportunityFormReducer.mailSent,
    mailFailed: state.sparkOpportunityFormReducer.mailFailed,
    postionsinfo: state.GetPositionsReducer.postionsinfo
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(AlumniNavigation);



// WEBPACK FOOTER //
// ./src/components/Inc/AlumniNavigation.js